import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MyValuesStartPage } from './my-values-start.page';

const routes: Routes = [
  {
    path: '',
    component: MyValuesStartPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MyValuesStartPageRoutingModule {}
